import React, { useState, useEffect } from "react";
import { Modal, Button, Container, Row, Col } from "react-bootstrap";
import CopyAllIcon from "@mui/icons-material/CopyAll";
import useApiServices from "../../utils/useApiServices";
import { GET_TN_TIMELINE_PAYIN, GET_TXN_TIMELINE } from "../../utils/constant";
import { Tooltip } from "@mui/material";
import {
  convertDateFormat,
  convertDateTimeFormat,
  convertTime,
} from "../../utils/helper";

const TxnTimeline = ({ type, id, setTimelineOpen }) => {
  const [show, setShow] = useState(true);
  const [showJson, setShowJson] = useState(false);
  const [showSummary, SetShowSummary] = useState(false);
  const [json, setJson] = useState({});
  const [keys, setKeys] = useState([]);
  const [timelineData, setTimelineData] = useState([]);
  const [txnSummary, setTxnSummary] = useState({});
  const { apiCallFnforGet } = useApiServices();

  useEffect(() => {
    const fetchTimeline = async () => {
      console.log("Fetching timeline for ID:", id, type);
      try {
        const res = await apiCallFnforGet(
          type === "referenceId"
            ? GET_TXN_TIMELINE + `?${type}=` + id
            : GET_TN_TIMELINE_PAYIN + `?${type}=` + id
        );

        if (res?.statusCode === 200 && res?.data?.length > 0) {
          setTxnSummary(res?.data[res?.data?.length - 1]?.transactionSummary);
          let item = res?.data?.slice(0, -1);
          if (type === "referenceId") {
            item = item.map((items) => ({
              ...items,
              status: items.status === "failure" ? "failed" : items.status,
            }));
          }
          setTimelineData(item);
          setKeys(item.map((items) => items.key));
        } else {
          setTimelineData([]);
          setTxnSummary({});
          setKeys(Object.keys([]));
        }
      } catch (err) {
        console.error("API error:", err);
        setTimelineData([]);
        setKeys(Object.keys([]));
      }
    };

    fetchTimeline();
  }, [id]);

  const getStatusIcon = (txnStatus, index) => {
    if (txnStatus === "success")
      return (
        <i
          className="fa-solid fa-check text-white fs-3"
          style={{ transform: "rotate(45deg)" }}
        ></i>
      );
    if (txnStatus === "failed")
      return (
        <i
          class="fa-solid fa-xmark text-white"
          style={{ transform: "rotate(45deg)" }}
        ></i>
      );
    return (
      <i
        className="fa-solid fa-clock text-white fs-4"
        style={{ transform: "rotate(45deg)" }}
      ></i>
    );
  };

  const formatLabel = (text) => {
    return text
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/^\w/, (c) => c.toUpperCase());
  };

  const copyJsonModalData = () => {
    navigator.clipboard.writeText(JSON.stringify(json, null, 2));
  };

  const handleJsonViewClick = (data) => {
    console.log(data);
    setJson(data?.data);
    setShowJson(true);
  };

  function msToFullTime(timeframe) {
    console.log(typeof timeframe, timeframe);
    const ms = Number(timeframe);
    console.log(typeof ms, ms);
    const milliseconds = ms % 1000;
    const totalSeconds = Math.floor(ms / 1000);
    const seconds = totalSeconds % 60;
    const totalMinutes = Math.floor(totalSeconds / 60);
    const minutes = totalMinutes % 60;
    const hours = Math.floor(totalMinutes / 60);

    const pad = (n, z = 2) => String(n).padStart(z, "0");

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}.${pad(
      milliseconds,
      3
    )}`;
  }

  return (
    <Modal show={show} centered size="xl" onHide={() => setShow(false)}>
      <Modal.Header className="text-white bg-dark">
        <Modal.Title className="fw-bold">View Txn Timeline </Modal.Title>
        <Button
          variant="light"
          onClick={() => {
            setShow(false);
            setTimelineOpen(false);
          }}
        >
          X
        </Button>
      </Modal.Header>
      <Modal.Body>
        <Container className="my-5">
          <Row className="justify-content-center">
            <Col md={12} className="d-flex justify-content-center w-100">
              {/* <h3 className="text-black"> Phase 1 </h3> */}
              <div className="d-flex flex-column align-items-center">
                <div className="d-flex justify-content-center w-50 ">
                  {timelineData?.slice(0, 4).map((item, index) => (
                    <div
                      className={`d-flex flex-column align-items-center `}
                      key={item?.key}
                      style={
                        index % 2 === 0
                          ? {
                              position: "relative",
                              padding: "5px",
                              backgroundColor: "transparent",
                              marginLeft: `${-20}px`,
                              marginBottom: "1px",
                              borderRadius: "100%",
                              border: "20px solid #333",
                              borderTopColor: "transparent",
                              borderRightColor: "transparent",
                              transform: "rotate(-45deg)",
                            }
                          : {
                              position: "relative",
                              backgroundColor: "transparent",
                              padding: "5px",
                              marginLeft: `${-20}px`,
                              marginTop: "1px",
                              borderRadius: "100%",
                              border: "20px solid #333",
                              borderBottomColor: "transparent",
                              borderLeftColor: "transparent",
                              transform: "rotate(-45deg)",
                            }
                      }
                    >
                      <div
                        className={`bg-success rounded-circle d-flex justify-content-center align-items-center ${
                          item.status === "success"
                            ? "bg-sucess"
                            : item?.status === "failed"
                            ? "bg-danger"
                            : "bg-warning"
                        }`}
                        style={{
                          width: 100,
                          height: 100,
                          cursor: "pointer",
                        }}
                        onClick={() => handleJsonViewClick(item)}
                      >
                        <span
                          className="text-black"
                          style={{
                            transform:
                              "translateX(10%) translateY(30%) rotate(45deg)",
                          }}
                        >
                          {msToFullTime(item?.timeframe.split(" ")[0])}
                        </span>
                        <span
                          className="text-black fs-4 fw-bold"
                          style={{
                            transform: "translateX(-160%) translateY(-10%)",
                          }}
                        >
                          {getStatusIcon(item?.status, index)}
                        </span>
                      </div>
                      {index % 2 === 0 ? (
                        <p
                          className="position-absolute text-black w-auto text-center"
                          style={{
                            top: "-30px", // adjust this to control vertical distance
                            left: "110%",
                            transform: "translateX(-50%) rotate(45deg)", // center & rotate
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.stage.replace(/_/g, " ")}
                          {/* {item?.key} */}
                          <br />
                          {convertDateTimeFormat(item.time)}
                        </p>
                      ) : (
                        <p
                          className="position-absolute text-black w-auto text-center"
                          style={{
                            top: "120px", // adjust this to control vertical distance
                            left: "-20%",
                            transform: "translateX(-50%) rotate(45deg)", // center & rotate
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.stage.replace(/_/g, " ")}
                          <br />
                          {convertDateTimeFormat(item.time)}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              {/* <h3 className="text-black"> Phase 2 </h3> */}
              <div className="d-flex flex-column align-items-center">
                <div className="d-flex justify-content-center w-50 mx-5">
                  {timelineData?.slice(4, 7).map((item, index) => (
                    <div
                      className={`d-flex flex-column align-items-center `}
                      key={item?.key}
                      style={
                        index % 2 === 0
                          ? {
                              position: "relative",
                              padding: "5px",
                              backgroundColor: "transparent",
                              marginLeft: `${-20}px`,
                              marginBottom: "1px",
                              borderRadius: "100%",
                              border: "20px solid #333",
                              borderTopColor: "transparent",
                              borderRightColor: "transparent",
                              transform: "rotate(-45deg)",
                            }
                          : {
                              position: "relative",
                              backgroundColor: "transparent",
                              padding: "5px",
                              marginLeft: `${-20}px`,
                              marginTop: "1px",
                              borderRadius: "100%",
                              border: "20px solid #333",
                              borderBottomColor: "transparent",
                              borderLeftColor: "transparent",
                              transform: "rotate(-45deg)",
                            }
                      }
                    >
                      <div
                        className={`bg-success rounded-circle d-flex justify-content-center align-items-center ${
                          item.status === "success"
                            ? "bg-sucess"
                            : item?.status === "failed"
                            ? "bg-danger"
                            : "bg-warning"
                        }`}
                        style={{
                          width: 100,
                          height: 100,
                          cursor: "pointer",
                        }}
                        onClick={() => handleJsonViewClick(item)}
                      >
                        <span
                          className="text-black"
                          style={{
                            transform:
                              "translateX(10%) translateY(30%) rotate(45deg)",
                          }}
                        >
                          {msToFullTime(item?.timeframe.split(" ")[0])}
                        </span>
                        <span
                          className="text-black fs-4 fw-bold"
                          style={{
                            transform: "translateX(-160%) translateY(-10%)",
                          }}
                        >
                          {getStatusIcon(item?.status, index)}
                        </span>
                      </div>
                      {index % 2 === 0 ? (
                        <p
                          className="position-absolute text-black w-auto text-center"
                          style={{
                            top: "-30px", // adjust this to control vertical distance
                            left: "110%",
                            transform: "translateX(-50%) rotate(45deg)", // center & rotate
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.stage.replace(/_/g, " ")}
                          {/* {item?.key} */}
                          <br />
                          {convertDateTimeFormat(item.time)}
                        </p>
                      ) : (
                        <p
                          className="position-absolute text-black w-auto text-center"
                          style={{
                            top: "120px", // adjust this to control vertical distance
                            left: "-20%",
                            transform: "translateX(-50%) rotate(45deg)", // center & rotate
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.stage.replace(/_/g, " ")}
                          <br />
                          {convertDateTimeFormat(item.time)}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        {/* JSON Viewer Modal */}
        <Modal show={showJson} centered onHide={() => setShowJson(false)}>
          <Modal.Header className="bg-dark text-white">
            <Modal.Title>Step JSON</Modal.Title>
            <Button variant="light" onClick={copyJsonModalData}>
              <CopyAllIcon />
            </Button>
          </Modal.Header>
          <Modal.Body>
            <pre style={{ maxHeight: "60vh", overflowY: "auto" }}>
              {JSON.stringify(json, null, 2)}
            </pre>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-danger" onClick={() => setShowJson(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={showSummary}
          centered
          size="lg"
          onHide={() => SetShowSummary(false)}
        >
          <Modal.Header className="bg-dark text-white">
            <Modal.Title className="text-bold">Transaction Summary</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <Row className="justify-content-center"> */}
            {txnSummary && (
              <Row>
                <Col md={6}>
                  <p>
                    <strong>Transaction Status:</strong>{" "}
                    {txnSummary.transactionStatus?.toUpperCase() || "-"}
                  </p>
                  <p>
                    <strong>Remark :</strong> {txnSummary.remark || "-"}
                  </p>
                  <p>
                    <strong>Payment Mode:</strong>{" "}
                    {txnSummary.paymentMode || "-"}
                  </p>
                  <p>
                    <strong>Transaction ID:</strong> {txnSummary.txnId || "-"}
                  </p>
                </Col>
                <Col md={6}>
                  <p>
                    <strong>Started At:</strong>{" "}
                    {txnSummary.startAt
                      ? convertDateTimeFormat(txnSummary.startAt)
                      : "-"}
                  </p>
                  <p>
                    <strong>Completed At:</strong>{" "}
                    {txnSummary.completedAt
                      ? convertDateTimeFormat(txnSummary.completedAt)
                      : "-"}
                  </p>
                  <p>
                    <strong>Total Duration:</strong>{" "}
                    {txnSummary.totalTxnDuration || "-"}
                  </p>
                  {/* <p>
                      <strong>Current Stage:</strong>{" "}
                      {txnSummary.currentStage?.replace(/_/g, " ") || "-"}
                    </p> */}
                </Col>
              </Row>
            )}
            {/* </Row> */}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="outline-danger"
              onClick={() => SetShowSummary(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Modal.Body>
      <Modal.Footer>
        {timelineData.length && (
          <div className="d-flex justify-content-around w-100 my-4">
            <h4 className="text-black border-top-2">
              {" "}
              <span>Phase 1 Time - (HH:mm:ss.SSS) :- </span>
              {msToFullTime(
                timelineData.slice(0, 4).reduce(
                  (acc, curr) =>
                    acc + (Number(curr.timeframe.split(" ")[0]) || 0),
                  0 // ← Initial value set to 0
                )
              )}
            </h4>
            <h4 className="text-black border-top-2">
              {" "}
              <span>Phase 2 Time - (HH:mm:ss.SSS) :- </span>
              {msToFullTime(
                timelineData.slice(4, 7).reduce(
                  (acc, curr) =>
                    acc + (Number(curr.timeframe.split(" ")[0]) || 0),
                  0 // ← Initial value set to 0
                )
              )}
            </h4>
          </div>
        )}
        <div className="w-100 d-flex justify-content-around align-items-center">
          <div className="text-black mr-4 fs-4">
            <span className="fw-bold">Transaction Remark :</span>{" "}
            <span className="fw-semibold">{txnSummary?.remark}</span>
          </div>
          <div className="d-flex align-items-center gap-2">
            <Button
              variant="btn btn-success"
              onClick={() => {
                SetShowSummary(true);
                // setTimelineOpen(false);
              }}
            >
              Show Summary
            </Button>
            <Button
              variant="outline-danger"
              onClick={() => {
                setShow(false);
                setTimelineOpen(false);
              }}
            >
              Close
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default TxnTimeline;
